/** The API returns shipping promise history in chronological order. */
export const latestShippingPromise = (value: string | string[] | null | undefined): string | null =>
  (Array.isArray(value) ? value[value.length - 1] : value) || null;
